<template>
    <div class="component particle-canvas">
        <svg
            viewBox="0 0 100 100"
            v-for="(particle, index) in particles"
            :key="`particle-${index}`"
            :class="['particle', `particle-${particle.shape}`, `size-${particle.size}`]"
            aria-hidden="true"
            :style="
                `top: ${particle.top}vh; right: ${particle.right}vw; bottom: ${particle.bottom}vw; left: ${particle.left}vw;`
            "
        >
            <path
                v-if="particle.shape === 'parallelogram'"
                d="M91.1,56.4l-31,32.7c-12.7,13.6-34.5,14.7-48.5,2.3l-0.5-0.4c-14-12.4-15-33.7-2.3-47.3l31-32.7C52.5-2.7,74.3-3.7,88.3,8.7l0.5,0.4C102.8,21.5,103.8,42.7,91.1,56.4"
                :class="forcedParticleColor ? `fill-${forcedParticleColor}` : `fill-${particle.color}`"
            />
            <circle
                v-if="particle.shape === 'circle'"
                cx="50"
                cy="50"
                r="50"
                :class="forcedParticleColor ? `fill-${forcedParticleColor}` : `fill-${particle.color}`"
            />
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'Particles',
        props: ['particles'],
        data() {
            return {
                forcedParticleColor: undefined,
            };
        },
        methods: {
            forceParticleColor(color) {
                if (color) {
                    this.forcedParticleColor = color;
                }
            },
            resetParticleColor() {
                this.forcedParticleColor = undefined;
            },
        },
    };
</script>

<style scoped lang="scss">
    .component.particle-canvas {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        pointer-events: none;
        user-select: none;
        -webkit-user-select: none;

        @media (max-width: breakpoint('large')) {
            display: none;

            .particle {
                animation: none;
            }
        }

        .particle {
            position: absolute;
            width: 75px;

            &.size-xs {
                width: 40px;
            }

            &.size-s {
                width: 60px;
            }

            &.size-l {
                width: 100px;
            }

            &.size-xl {
                width: 150px;
            }

            * {
                transition: fill 0.5s;
            }

            @media (max-height: 750px) {
                width: calc(75px * 0.7);

                &.size-xs {
                    width: calc(40px * 0.7);
                }

                &.size-s {
                    width: calc(60px * 0.7);
                }

                &.size-l {
                    width: calc(100px * 0.7);
                }

                &.size-xl {
                    width: calc(150px * 0.7);
                }
            }
        }

        @keyframes anim-particle-float {
            0% {
                transform: translateY(0px);
            }

            50% {
                transform: translateY(15px);
            }

            100% {
                transform: translateY(0px);
            }
        }
    }

    .section.active .particle {
        animation: anim-particle-float 4s infinite linear;
    }
</style>
